import _cloneDeep from 'lodash/cloneDeep';
import initialState from './initialState';
import actionTypes from './actionTypes';

const cashExplorerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ALL_GROUP_ITEM: {
            return {
                ...state,
                records: action.payload,
            };
        }
        case actionTypes.GET_EXCEPTION_ITEM: {
            return {
                ...state,
                exceptionRecords: action.payload,
            };
        }
        case actionTypes.GET_EXCEPTION_LABEL_ITEM: {
            return {
                ...state,
                exceptionLabels: action.payload,
            };
        }
        case actionTypes.GET_TA_RECON_ORDERS: {
            return {
                ...state,
                taReconOrders: action.payload,
            };
        }
        case actionTypes.GET_ALL_EXCEPTION_ITEM: {
            return {
                ...state,
                allExceptionRecords: action.payload,
            };
        }
        case actionTypes.GET_VIEW_TREE: {
            return {
                ...state,
                treeData: action.payload,
            };
        }
        case actionTypes.GET_NODE_TREE: {
            return {
                ...state,
                nodes: action.payload,
            };
        }
        case actionTypes.GET_FUNDS_NODE_TREE: {
            return {
                ...state,
                fundsNodes: action.payload,
            };
        }
        case actionTypes.GET_ALL_AUTH: {
            return {
                ...state,
                authRecords: action.payload,
            };
        }
        case actionTypes.GET_AUDIT_RECORDS: {
            return {
                ...state,
                auditrecords: action.payload,
            };
        }
        case actionTypes.GET_ACCOUNTS_LIST: {
            return {
                ...state,
                accountsList: action.payload,
            };
        }
        case actionTypes.GET_REFDATA_SETTINGS: {
            return {
                ...state,
                refDataSettings: action.payload,
            };
        }
        case actionTypes.GET_HOLDING_RECON_DATA: {
            return {
                ...state,
                hreconData: action.payload,
            };
        }
        case actionTypes.GET_TRANSACTION_TYPE: {
            return {
                ...state,
                transactionType: action.payload,
            };
        }
        case actionTypes.GET_RECON_DATE: {
            return {
                ...state,
                reconDate: action.payload,
            };
        }
        default:
            return state;
    }
};

export default cashExplorerReducer;
